const onlyDigits = (flags = 'g') => new RegExp(/\d/, flags);

const nonDigit = (flags = 'g') => new RegExp(/\D/, flags);

const whiteSpace = (flags = 'g') => new RegExp(/\s/, flags);

const comma = (flags = 'g') => new RegExp(/\,\s?/, flags);

// matches n-th characters
const groupByNth = (nth, flags = 'g') => new RegExp(`.{1,${nth}}`, flags);

const accents = (flags = 'g') => new RegExp(/[\u0300-\u036f]/, flags);

export {
  onlyDigits,
  nonDigit,
  whiteSpace,
  groupByNth,
  accents,
  comma,
}
